module.exports = "<div class=\"users-card-element\">\n  <h1>Lehden toimitus</h1>\n  <div class=\"users-list credits\">\n    <span *ngFor=\"let user of users\" class=\"author\">\n      {{user.first_name}} {{user.last_name}},\n    </span>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/users-card/users-card.component.html
// module id = 213
// module chunks = 1